export const HOME_PAGE_LOAD = "5Eq";
export const HOME_PAGE_UNLOAD = "5Es";
export const CHANGE_TOKEN = "3dS";
export const BROADCAST_STATE = "BROADCAST_STATE";